export default "__VITE_ASSET__5e1161e1__"